import React, { useState, useEffect } from 'react'

import useModal from 'hook/useModal'
// css
import 'assets/style/common.scss'

// elements
import { SearchBar, Text, ListTitle, Line, InputRadio, BottomButton } from 'components'
import { useCommonSite } from 'api/common/site-fetch'

// 사이트 검색
function SteSrch({ keywords = '', ok = () => {} }) {
  const { alertModal, confirmModal, closeModal } = useModal()
  const [isInit, setIsInit] = useState(false)
  const [selected, setSelected] = useState(-1)

  const [list, setList] = useState([])

  const [queryOptions, setQueryOptions] = useState({
    searchShp: '',
    searchSiteId: keywords,
  })

  const { data, isSuccess } = useCommonSite(queryOptions, isInit)

  useEffect(() => {
    if (isSuccess) {
      setList(data?.data)
    }
  }, [data])

  return (
    <main>
      {/* todo: 팝업 헤더 */}
      <div className="wrapper">
        <Text text="사이트명/사이트코드" className="mb16 f-16 f-bold c-3 " />
        <SearchBar
          goSearch={(value) => {
            if (value == '') {
              alertModal('검색어를 입력해주세요.')
              return
            }
            console.log('검색', value)
            setIsInit(true)
            setQueryOptions({ ...queryOptions, searchSiteId: value })
          }}
        />
      </div>

      <ListTitle title="검색결과" count={list.length} className="wrapper mt16" />

      <Line size="1" color="gray" />

      <ul className="wrapper basic-list mb40">
        {list.length ? (
          list.map((item, index) => (
            <li className="flex flex-1" key={item.siteId}>
              <InputRadio
                onClick={() => setSelected(index)}
                checked={selected === index}
                title={
                  <div className="flex-col flex-1 gap-4">
                    <Text className="f-14 mono-6" text={item.orgNm} />
                    <Text
                      className="f-14 mono-3"
                      text={`[${item.shpId}] ${item.shpNm} > [${item.siteId}] ${item.siteNm}`}
                    />
                  </div>
                }
                name="r1"
                className="flex1"
              />
            </li>
          ))
        ) : (
          <Text className="flex py10 flex-center f-14 mono-b" text="대상 사이트 정보가 없습니다." />
        )}
      </ul>

      <BottomButton
        data={[{ title: '선택', color: 'primary' }]}
        onClick={() => {
          if (selected < 0) {
            alertModal('사이트를 선택해주세요.')
            return
          }

          ok(list[selected])
          closeModal()
        }}
      />
    </main>
  )
}

export default SteSrch
